export const toggleSideNav = () => ({
    type: 'TOGGLE_NAV',
});
